module.exports = __webpack_public_path__ + "img/icons BFr_2.c0f18db8.png";